import { firestore } from "../../config/firebase";
import { doc, updateDoc } from "firebase/firestore";

const updateReport = async (id, obj) => {
  const reportsRef = doc(firestore, "reports", id);
  await updateDoc(reportsRef, obj);
};

export default updateReport;